var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":Boolean(_vm.value),"variant":"danger","dismissible":_vm.dismissible},on:{"dismissed":function($event){return _vm.$emit('dismissed')}}},[_vm._v(" "+_vm._s(_vm.message)+" "),(_vm.action)?_c('span',{staticClass:"action",on:{"click":_vm.onAction}},[_vm._v(_vm._s(_vm.action))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }